import { h, Component } from 'preact'

interface CountdownState {
  timeLeft: string
  days: number
  hours: number
  minutes: number
  seconds: number
}

interface CountdownProps {
  'data-end-date': string
  'data-wrapper-class'?: string
  'data-item-class'?: string
  'data-numbers-class'?: string
  'data-text-class'?: string
  'data-success-message'?: string
  'data-countdown-layout'?: string
}

export class CountdownElement extends Component<CountdownProps, CountdownState> {
  private timer: number | null = null
  private endTime: number = 0

  constructor() {
    super()
    this.updateCountdown = this.updateCountdown.bind(this)
    this.state = {
      timeLeft: '',
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    }
  }

  componentDidMount() {
    const hostElement = (this.base as any)?.parentElement
    if (hostElement && hostElement.tagName === 'X-COUNTDOWN') {
      hostElement.innerHTML = ''
    }

    const endDate = this.props['data-end-date']
    if (endDate) {
      this.endTime = new Date(endDate).getTime()
      this.updateCountdown()
      this.timer = window.setInterval(this.updateCountdown, 1000)
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  updateCountdown() {
    const now = new Date().getTime()
    const timeDiff = this.endTime - now

    if (timeDiff < 1) {
      this.setState({
        timeLeft: '',
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      })
      if (this.timer) {
        clearInterval(this.timer)
      }
      // window.location.reload()
      return
    }

    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
    const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000)

    this.setState({
      timeLeft: `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`,
      days,
      hours,
      minutes,
      seconds
    })
  }

  render() {
    const successMessage = this.props['data-success-message'] || 'Available now!'

    if (this.state.timeLeft === '' && this.state.days === 0 && this.state.hours === 0 && this.state.minutes === 0 && this.state.seconds === 0) {
      return h('span', { class: '' }, successMessage)
    }

    // Get classes from props or use defaults
    const wrapperClass = this.props['data-wrapper-class'] || 'flex gap-x-1.25'
    const itemClass = this.props['data-item-class'] || 'flex flex-col gap-y-0.5 items-center justify-center text-center'
    const numbersClass = this.props['data-numbers-class'] || 'text-4xl font-heading font-semibold leading-none'
    const textClass = this.props['data-text-class'] || 'text-xxs font-semibold uppercase'
    const countdownLayout = this.props['data-countdown-layout'] || 'large'

    return h('div', { class: wrapperClass }, [
      h('div', { class: itemClass }, [
        h('span', { class: numbersClass }, this.state.days.toString().padStart(2, '0')),
        h('span', { class: textClass }, countdownLayout === 'large' ? 'Days' : 'd')
      ]),
      h('div', { class: itemClass }, [
        h('span', { class: numbersClass }, this.state.hours.toString().padStart(2, '0')),
        h('span', { class: textClass }, countdownLayout === 'large' ? 'Hrs' : 'h')
      ]),
      h('div', { class: itemClass }, [
        h('span', { class: numbersClass }, this.state.minutes.toString().padStart(2, '0')),
        h('span', { class: textClass }, countdownLayout === 'large' ? 'Mins' : 'm')
      ]),
      h('div', { class: itemClass }, [
        h('span', { class: numbersClass }, this.state.seconds.toString().padStart(2, '0')),
        h('span', { class: textClass }, countdownLayout === 'large' ? 'Secs' : 's')
      ])
    ])
  }
}
